<xm-utility-banner></xm-utility-banner>
<nav class="main-nav" role="navigation">
    <div class="links" hidden>
        <ul class="left">
            <xm-nav-logo [checkoutNavLogo]="true"></xm-nav-logo>
        </ul>
    </div>
</nav>
